import type { ReactNode } from "react";

/**
 * Live Breadth — its own top-level section, kept SEPARATE from Market Timing
 * (and Dashboard). Single page, so no sub-tab bar.
 */
export default function LiveBreadthLayout({ children }: { children: ReactNode }) {
  return (
    <main className="legacy-light w-full px-6 py-2 xl:px-8 2xl:px-10">
      {children}
    </main>
  );
}
